<template lang="pug">
.registration-flyout__error(:id="this.error.id" v-if="showError")
    p 
        i.fas.fa-times
        | {{this.error.description}}
</template>
    
<script>
    export default {
        name: "AlertError",
        data() {
            return{
                
            }
        },
        props: {
            error:{
                default: () => ({
                    description: 'An error has occurred, please check your email and password',
                    id: 'error'
                }),
                type: Object
            } 
        },
        computed: {
            showError() { return this.error?.code !== "DuplicateUserName" }
        },
    }
</script>
    
<style lang="scss">

</style>
    